var _dec, _dec2, _dec3, _dec4, _dec5, _class, _class2, _descriptor, _descriptor2, _descriptor3;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
import { useFacetsStore, useSearchWizardStore } from '#imports';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import FilterAndSortFacetsGroupDefault from './FilterAndSortFacetsGroupDefault.vue';
import FilterAndSortFacetsGroupRanked from './FilterAndSortFacetsGroupRanked.vue';
var FilterAndSortFacets = (_dec = Component({
  components: {
    'filter-and-sort-facets-group-default': FilterAndSortFacetsGroupDefault,
    'filter-and-sort-facets-group-ranked': FilterAndSortFacetsGroupRanked
  },
  setup() {
    var facetsStore = useFacetsStore();
    var searchWizardStore = useSearchWizardStore(usePinia());
    return {
      facetsStore,
      searchWizardStore
    };
  }
}), _dec2 = Prop({
  default: () => []
}), _dec3 = Prop(), _dec4 = Prop(), _dec5 = Watch('selectedFacets', {
  immediate: true
}), _dec(_class = (_class2 = class FilterAndSortFacets extends Vue {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "selectedFacets", _descriptor, this);
    _initializerDefineProperty(this, "facetCounts", _descriptor2, this);
    _initializerDefineProperty(this, "initialFacetCounts", _descriptor3, this);
    this.selectedPerGroup = {};
  }
  get facetGroups() {
    return this.facetsStore.facetGroups || [];
  }
  facetsChange(changes) {
    this.$emit('changeFacets', this.recalculateSelectedFacets(changes));
  }
  getFacetGroupComponent(type) {
    return "filter-and-sort-facets-group-".concat(type);
  }
  get visibleGroups() {
    return this.facetGroups.map(group => _objectSpread(_objectSpread({}, group), {}, {
      facets: group.hideEmpty ? group.facets.filter(facet =>
      // if we are not showing counts then show all
      !this.searchWizardStore.showCount ||
      // otherwise only show the facets that match initial counts
      this.initialFacetCounts[facet.slug] || this.facetCounts[facet.slug]) : group.facets
    })).filter(group => group.facets.length > 0 && group.slug !== 'campsite-group');
  }
  recalculateSelectedFacets(changes) {
    var facetsRemoved = [];
    var tmpFacets = [...this.selectedFacets];
    for (var [slug, isAdded] of changes) {
      isAdded ? tmpFacets.push(slug) : facetsRemoved.push(slug);
      this.updateSelectedCounts(slug, isAdded);
    }
    return tmpFacets.filter(slug => !facetsRemoved.includes(slug));
  }
  selectedFacetsChanged() {
    this.setupGroupCounts();
  }
  setupGroupCounts() {
    var selectedPerGroup = {};
    for (var group of this.visibleGroups) {
      selectedPerGroup[group.slug] = 0;
    }
    this.selectedPerGroup = selectedPerGroup;
    for (var facet of this.selectedFacets) {
      this.updateSelectedCounts(facet, true);
    }
  }
  updateSelectedCounts(selectedFacet, checked) {
    var parentGroupsForSelectedFacet = this.facetGroups.filter(slug => slug.facets.some(facet => facet.slug === selectedFacet)).map(facetGroups => facetGroups.slug);
    for (var parentGroup of parentGroupsForSelectedFacet) {
      if (checked) {
        this.selectedPerGroup[parentGroup]++;
      } else {
        this.selectedPerGroup[parentGroup]--;
      }
    }
  }
}, (_descriptor = _applyDecoratedDescriptor(_class2.prototype, "selectedFacets", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "facetCounts", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "initialFacetCounts", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class2.prototype, "selectedFacetsChanged", [_dec5], Object.getOwnPropertyDescriptor(_class2.prototype, "selectedFacetsChanged"), _class2.prototype)), _class2)) || _class);
export { FilterAndSortFacets as default };